import { render, staticRenderFns } from "./ServiceCrud.vue?vue&type=template&id=432e073e&scoped=true&"
import script from "./ServiceCrud.vue?vue&type=script&lang=js&"
export * from "./ServiceCrud.vue?vue&type=script&lang=js&"
import style0 from "./ServiceCrud.vue?vue&type=style&index=0&id=432e073e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432e073e",
  null
  
)

export default component.exports